<script setup>
  import { ref, computed, watchEffect } from 'vue';

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    drawingManager: {
      type: Object,
      required: true
    },
    points: {
      type: Array,
      required: true
    },
    radiusDistance: {
      type: Number,
      default: 0
    },
    fillColor: {
      type: String,
      default: '#FF0000'
    },
    fillOpacity: {
      type: Number,
      default: 1.0
    },
    strokeColor: {
      type: String,
      default: '#FF0000'
    },
    strokeOpacity: {
      type: Number,
      default: 1.0
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  });

  const strokeColor = ref(props.strokeColor);
  const strokeOpacity = ref(props.strokeOpacity);
  const strokeWidth = ref(props.strokeWidth);

  const centerPoint = computed(() => props.points.length === 0 ? false : props.points[0]);
  const radius = computed(() => {
    return props.drawingManager.getCircleRadius(
      props.points,
      props.radiusDistance
    );
  });

  watchEffect(() => {
    strokeColor.value = props.strokeColor;
    strokeOpacity.value = props.strokeOpacity;
    strokeWidth.value = props.strokeWidth;
  });
</script>

<template>
  <circle 
    v-if="centerPoint"
    :id="props.id"
    :cx="centerPoint.x"
    :cy="centerPoint.y"
    :r="radius"
    :fill="props.fillColor"
    :fill-opacity="`${props.fillOpacity}%`"
    :stroke="props.strokeColor"
    :stroke-width="props.strokeWidth"
    :stroke-opacity="`${props.strokeOpacity}%`"
    paint-order="fill"
  />
</template>